/** Misty Croft — provisional pink-forward palette */
export const MISTYCROFT_PRIMARY_COLOR = '#D4588C';
export const MISTYCROFT_SECONDARY_COLOR = '#9B5A78';
export const MISTYCROFT_TERTIARY_COLOR = '#ffffff';
export const MISTYCROFT_PULSE_COLOR = '#E879A8';
export const MISTYCROFT_PRIMARY_LIGHT_COLOR = '#F5A3C4';
export const MISTYCROFT_HIGHLIGHT_COLOR = '#FCE4EC';
